import React from "react";
import styles from "./EmployeeTable.module.css";
import { useField, useFormikContext } from "formik";
import { SystemIcon } from "@justworkshr/milo-components";
import { DateInput as MiloInput } from "@justworkshr/milo-form";

interface IDateInputProps {
  name: string;
}

const TableDateInput = ({ ...props }: IDateInputProps): JSX.Element => {
  const { name } = props;
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  return (
    <div>
      <MiloInput
        className={styles.dateInput}
        id={name}
        {...field}
        data-testid={name}
        onAccept={(val) =>
          setFieldValue(field.name, val === "_ _ /_ _ /_ _ _ _" ? "" : val)
        }
      />
      {meta.touched && meta.error && (
        <span className={styles.fieldError}>
          <SystemIcon iconName="error" color="error" size="small" />
          {meta.error}
        </span>
      )}
    </div>
  );
};

export default TableDateInput;
